import { useCallback } from "react";
import { useStorage, type SupportedLocale } from "@repo/core";
import { isLocaleLocked } from "./localeMeta";
import { writeStoredLocale } from "./translations";
import { relocalizeDefaultCategoryNames } from "../lib/db";

export function useT() {
  const { i18n, locale, setLocale: setLocaleRaw } = useStorage();
  const locked = isLocaleLocked();

  const t = useCallback(
    (key: string, vars?: Record<string, string | number>) => i18n.t(key, vars),
    [i18n]
  );

  const setLocale = useCallback(
    async (next: SupportedLocale) => {
      if (isLocaleLocked()) return;
      writeStoredLocale(next);
      setLocaleRaw(next);
      // Keep default category names in DB aligned with the UI language
      await relocalizeDefaultCategoryNames(next);
    },
    [setLocaleRaw]
  );

  return { t, locale, setLocale, i18n, localeLocked: locked };
}
